export default "__VITE_ASSET__5c0dd036__"